import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import useLogout from '../Auth/hooks/useLogout';
import { appRoutes } from '../../path';
import { getScrollBarStyles } from '../../config/styles';
import { ReactComponent as ErrorPageAsset } from '../../assets/images/error-page-asset.svg';
import { theme } from '../../styles/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  min-height: 100%;
  max-height: 100%;
  padding: 48px;
  background-color: #f3f5f7;
  overflow-y: auto;
  ${getScrollBarStyles(2)};
`;
const ImageContainer = styled.div`
  flex: 0 0 auto;
  margin-top: auto;
  margin-right: auto;
  margin-left: auto;
`;
const ErrorMessage = styled.h1`
  flex: 0 0 auto;
  margin: 0 auto;
  text-align: center;
  max-width: 888px;
  font: inherit;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  color: #222;
`;
const ActionsContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: auto;
`;
const StyledPrimaryButton = styled.button`
  width: 160px;
  background: transparent;
  border: ${theme.colors.secondary900} 1px solid;
  cursor: pointer;
  min-height: 32px;
  font-size: 14px;
  border-radius: 4px;

  :hover {
    color: ${theme.colors.mainBlue};
  }
`;

/**
 * Isolate Error page with all hooks
 */
export default function ErrorPage() {
  const searchParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  );

  const message = searchParams.get('message');

  const handleLogout = useLogout();

  const onHomepageClick = () => {
    window.location.pathname = '/';
  };

  useEffect(() => {
    if (searchParams) {
      console.error(`Error Type: ${searchParams.get('type')}`);
      console.error(`Error Operation Name: ${searchParams.get('operation')}`);
      console.error(`Error Message: ${message}`);

      // clean-up search params from URL
      window.history.replaceState({}, document.title, appRoutes.errorPage);
    }
  }, [message, searchParams]);

  return (
    <Container>
      <ImageContainer>
        <ErrorPageAsset />
      </ImageContainer>
      <ErrorMessage>{message || 'Something went wrong'}</ErrorMessage>
      <ActionsContainer>
        <StyledPrimaryButton onClick={onHomepageClick}>
          Go to Homepage
        </StyledPrimaryButton>
        <StyledPrimaryButton onClick={handleLogout}>
          Re-Login
        </StyledPrimaryButton>
      </ActionsContainer>
    </Container>
  );
}
